import React, { useMemo, useState } from 'react'

import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { IS_I18N_ENABLED } from '@src/constants/storage'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

import useRecommendation from '../hooks/useRecommendation'
import { useProductPageExpData } from '../templates/productPage/productPage.utils'

import ProductPageContext from './ProductPageContext'

interface ProductPageContextProviderProps {
  children: React.ReactNode
  showFullPDP?: boolean
  updateShowFullPDPInSession?: (val: boolean) => void
}

const ProductPageContextProvider = ({
  children,
  showFullPDP = false,
  updateShowFullPDPInSession = (_: boolean) => {
    //Empty
  },
}: ProductPageContextProviderProps) => {
  const { productPageExpData, similarProductExpData } = useProductPageExpData(showFullPDP)
  const { recommendationUIData, isRecommendationLoading, updateRecommendationAPIData } =
    useRecommendation(productPageExpData)
  const [hasMoreToExplore, setHasMoreToExplore] = useState<boolean>(false)

  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.USE_NEW_PDP_RECOMMENDATIONS)

  const newPDPRecommendations = {
    isInBucket: IS_I18N_ENABLED
      ? true
      : experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.USE_NEW_PDP_RECOMMENDATIONS].buckets?.show,
    isInitialized: IS_I18N_ENABLED ? true : init,
  }

  const value = useMemo(
    () => ({
      isRecommendationLoading,
      updateRecommendationAPIData,
      hasMoreToExplore,
      setHasMoreToExplore,
      productPageExpData,
      showFullPDP,
      setShowFullPDP: updateShowFullPDPInSession,
      similarProductExpData,
    }),
    [isRecommendationLoading, hasMoreToExplore, productPageExpData, showFullPDP, similarProductExpData],
  )
  return (
    <ProductPageContext.Provider value={{ ...value, recommendationUIData, newPDPRecommendations }}>
      {children}
    </ProductPageContext.Provider>
  )
}

export default ProductPageContextProvider
